import React from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";
import { ChevronDown, ChevronUp } from "@domestika-dev/prudencio/dist/atoms/Icons";

import {
  customStyles,
  customStylesWithError,
  customSingleTheme,
  customTheme,
} from "../styles/multiSelect";

const DropdownIndicator = props => {
  const { isFocused } = props;
  return (
    <components.DropdownIndicator {...props}>
      {isFocused ? <ChevronUp /> : <ChevronDown />}
    </components.DropdownIndicator>
  );
};

DropdownIndicator.propTypes = {
  isFocused: PropTypes.bool.isRequired,
};

const ReactSelect = ({
  label,
  name,
  id,
  onChange,
  onFocusElement,
  required,
  defaultValue,
  options,
  loading,
  placeholderMessage,
  isMulti,
  isSearchable,
  noOptionsMessage,
  hasError,
  ...rest
}) => {
  return (
    <Form.Field size="small" label={label} required={required} name={name} id={id} {...rest}>
      <Select
        required={required}
        name={name}
        booleanProperties
        id={id}
        closeMenuOnSelect={false}
        components={{ DropdownIndicator }}
        styles={hasError ? customStylesWithError : customStyles}
        theme={isMulti ? customTheme : customSingleTheme}
        onChange={selected => onChange(selected, id)}
        onFocus={onFocusElement}
        isMulti={isMulti}
        defaultValue={defaultValue}
        options={options}
        loading={loading}
        placeholder={placeholderMessage}
        isSearchable={isSearchable}
        noOptionsMessage={() => noOptionsMessage}
      />
    </Form.Field>
  );
};

ReactSelect.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocusElement: PropTypes.func,
  required: PropTypes.bool,
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  loading: PropTypes.bool,
  placeholderMessage: PropTypes.string.isRequired,
  isMulti: PropTypes.bool,
  isSearchable: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  hasError: PropTypes.bool,
};

ReactSelect.defaultProps = {
  label: "",
  name: "",
  id: "",
  onChange: () => {},
  onFocusElement: () => {},
  required: false,
  defaultValue: [],
  options: [],
  loading: false,
  placeholderMessage: "",
  isMulti: false,
  isSearchable: false,
  noOptionsMessage: "No options",
  hasError: false,
};

export default ReactSelect;
